/* RCPO 360 viewer — lightbox con rotazione drag-to-spin a sequenza di fotogrammi.
   Implementazione vanilla JS equivalente al viewer GLightbox+Magic360 di pisa1940:
   overlay scuro, slide 360 + slide statiche con frecce, hint "Drag to spin",
   drag/touch con inerzia, rotellina = 1 frame, click = zoom 2.2x con pan. */
(function () {
  'use strict';

  var ICONS = {
    prev: '<svg viewBox="0 0 9 15" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false"><path d="M8.14.62c.48.48.48 1.25 0 1.73L3.5 7.5l4.64 5.15c.48.48.48 1.25 0 1.73-.48.48-1.26.48-1.74 0L.86 8.37a1.22 1.22 0 0 1 0-1.74L6.4.62c.48-.48 1.26-.48 1.74 0Z"/></svg>',
    next: '<svg viewBox="0 0 9 15" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false"><path d="M.86.62a1.23 1.23 0 0 1 1.74 0l5.54 6.01c.48.48.48 1.26 0 1.74l-5.54 6.01c-.48.48-1.26.48-1.74 0a1.23 1.23 0 0 1 0-1.73L5.5 7.5.86 2.35a1.23 1.23 0 0 1 0-1.73Z"/></svg>',
    close: '<svg viewBox="0 0 18 18" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false"><path d="M1.3 1.3a1 1 0 0 1 1.4 0L9 7.6l6.3-6.3a1 1 0 1 1 1.4 1.4L10.4 9l6.3 6.3a1 1 0 0 1-1.4 1.4L9 10.4l-6.3 6.3a1 1 0 0 1-1.4-1.4L7.6 9 1.3 2.7a1 1 0 0 1 0-1.4Z"/></svg>',
    spin: '<svg viewBox="0 0 60 30" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false"><path d="M30 5.5C16.5 5.5 5.5 9.9 5.5 15.5S16.5 25.5 30 25.5s24.5-4.4 24.5-10c0-3.8-5-7.2-12.6-8.9" fill="none" stroke="#fff" stroke-width="2.6" stroke-linecap="round"/><path d="M45.5 1.2l-7.3 4.9 8.2 4.3-.9-9.2z" fill="#fff"/></svg>'
  };

  function frameNumber(name) {
    var m = /360M[^0-9]*([0-9]+)/i.exec(name || '');
    return m ? parseInt(m[1], 10) : 9999;
  }

  function prefersReducedMotion() {
    return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function el(tag, cls, html) {
    var n = document.createElement(tag);
    if (cls) n.className = cls;
    if (html) n.innerHTML = html;
    return n;
  }

  function Viewer(data) {
    var list = (data.frames || []).slice();
    // gli URL da File Shopify non hanno il resize: uniforma a width=1024
    list.forEach(function (f) {
      if (!/[?&]width=/.test(f.u)) {
        f.u += (f.u.indexOf('?') >= 0 ? '&' : '?') + 'width=1024';
      }
    });
    list.sort(function (a, b) { return frameNumber(a.f) - frameNumber(b.f); });
    // dedup per numero frame: a parità vince la prima occorrenza (media prodotto prima dei File)
    var seenFrames = {};
    this.frames = list.filter(function (f) {
      var n = frameNumber(f.f);
      if (seenFrames[n]) return false;
      seenFrames[n] = true;
      return true;
    });
    this.slides = data.slides || [];
    this.alt = data.alt || '';
    this.hintText = data.hint || 'Drag to spin';
    this.spinLabel = data.spinLabel || '360°: use arrow keys to spin, Enter to zoom';
    this.slideCount = (this.frames.length ? 1 : 0) + this.slides.length;
    this.current = 0;
    this.frameIndex = 0;
    this.loaded = [];
    this.loadedCount = 0;
    this.settled = 0;
    this.preloadStarted = false;
    this.interacted = false;
    this.zoomed = false;
    this.overlay = null;
    this.lastFocus = null;
    this._raf = null;
  }

  Viewer.prototype.build = function () {
    if (this.overlay) return;
    var self = this;

    var overlay = el('div', 'rcpo360-overlay');
    overlay.setAttribute('role', 'dialog');
    overlay.setAttribute('aria-modal', 'true');
    overlay.setAttribute('aria-label', this.alt || '360');

    var stage = el('div', 'rcpo360-stage');
    var track = el('div', 'rcpo360-track');

    if (this.frames.length) {
      var spin = el('div', 'rcpo360-slide');
      var wrap = el('div', 'rcpo360-slide__frame rcpo360-spin');
      wrap.setAttribute('tabindex', '0');
      wrap.setAttribute('role', 'application');
      wrap.setAttribute('aria-label', this.spinLabel);
      var img = el('img');
      img.alt = this.alt;
      img.draggable = false;
      wrap.appendChild(img);

      var hint = el('div', 'rcpo360-hint');
      var msg = el('span', 'rcpo360-hint-message', ICONS.spin + '<span>' + this.hintText + '</span>');
      hint.appendChild(msg);
      wrap.appendChild(hint);

      var loader = el('div', 'rcpo360-loader', '0%');
      wrap.appendChild(loader);

      spin.appendChild(wrap);
      track.appendChild(spin);

      this.spinImg = img;
      this.spinWrap = wrap;
      this.hint = hint;
      this.loader = loader;
      this.bindSpin(wrap);
    }

    this.slides.forEach(function (s) {
      var slide = el('div', 'rcpo360-slide');
      var wrap = el('div', 'rcpo360-slide__frame');
      var img = el('img');
      img.src = s.u;
      img.alt = self.alt;
      img.loading = 'lazy';
      img.draggable = false;
      wrap.appendChild(img);
      slide.appendChild(wrap);
      track.appendChild(slide);
    });

    stage.appendChild(track);
    overlay.appendChild(stage);

    var prev = el('button', 'rcpo360-btn rcpo360-prev', ICONS.prev);
    prev.type = 'button';
    prev.setAttribute('aria-label', 'Previous');
    var next = el('button', 'rcpo360-btn rcpo360-next', ICONS.next);
    next.type = 'button';
    next.setAttribute('aria-label', 'Next');
    var close = el('button', 'rcpo360-btn rcpo360-close', ICONS.close);
    close.type = 'button';
    close.setAttribute('aria-label', 'Close');
    overlay.appendChild(prev);
    overlay.appendChild(next);
    overlay.appendChild(close);

    prev.addEventListener('click', function () { self.goTo(self.current - 1); });
    next.addEventListener('click', function () { self.goTo(self.current + 1); });
    close.addEventListener('click', function () { self.close(); });

    // click sull'area vuota della slide = chiudi (come GLightbox);
    // MA non se e' il click sintetico generato dal rilascio di un drag di spin
    // finito appena fuori dall'immagine (chiuderebbe l'overlay a meta' rotazione)
    stage.addEventListener('click', function (e) {
      if (self._lastDragEnd && e.timeStamp - self._lastDragEnd < 400) return;
      if (e.target.classList && e.target.classList.contains('rcpo360-slide')) self.close();
    });

    this._onKey = function (e) {
      if (e.key === 'Escape') { self.close(); }
      else if (e.key === 'ArrowLeft') { self.goTo(self.current - 1); }
      else if (e.key === 'ArrowRight') { self.goTo(self.current + 1); }
      else if (e.key === 'Tab') {
        var btns = [];
        if (self.spinWrap && self.current === 0) btns.push(self.spinWrap);
        [prev, next, close].forEach(function (b) { if (!b.disabled) btns.push(b); });
        if (!btns.length) return;
        var i = btns.indexOf(document.activeElement);
        e.preventDefault();
        var ni = e.shiftKey ? (i <= 0 ? btns.length - 1 : i - 1) : (i === btns.length - 1 || i < 0 ? 0 : i + 1);
        btns[ni].focus();
      }
    };

    this.overlay = overlay;
    this.track = track;
    this.prevBtn = prev;
    this.nextBtn = next;
    this.closeBtn = close;
  };

  Viewer.prototype.open = function () {
    var self = this;
    this.build();
    if (this._closeTimer) { clearTimeout(this._closeTimer); this._closeTimer = null; }
    this.lastFocus = document.activeElement;
    document.body.appendChild(this.overlay);
    document.documentElement.classList.add('rcpo360-lock');
    document.addEventListener('keydown', this._onKey);
    this.goTo(0, true);
    this.preload();
    var reveal = function () {
      if (!self.overlay) return;
      self.overlay.classList.add('is-open');
      self.closeBtn.focus();
    };
    // doppio rAF per far partire la transizione; timer di riserva se il
    // rendering è sospeso (tab in background)
    requestAnimationFrame(function () { requestAnimationFrame(reveal); });
    setTimeout(reveal, 80);
  };

  Viewer.prototype.close = function () {
    var self = this;
    if (!this.overlay || !this.overlay.parentNode) return;
    this.stopInertia();
    this.overlay.classList.remove('is-open');
    document.documentElement.classList.remove('rcpo360-lock');
    document.removeEventListener('keydown', this._onKey);
    this._closeTimer = setTimeout(function () {
      self._closeTimer = null;
      if (self.overlay && self.overlay.parentNode) self.overlay.parentNode.removeChild(self.overlay);
    }, 220);
    if (this.lastFocus && this.lastFocus.focus) this.lastFocus.focus();
  };

  Viewer.prototype.goTo = function (i, instant) {
    if (i < 0 || i > this.slideCount - 1) return;
    this.current = i;
    if (instant) this.track.style.transition = 'none';
    this.track.style.transform = 'translateX(' + (-i * 100) + '%)';
    if (instant) {
      void this.track.offsetWidth;
      this.track.style.transition = '';
    }
    this.prevBtn.disabled = i === 0;
    this.nextBtn.disabled = i === this.slideCount - 1;
    if (this.zoomed) this.setZoom(false);
    this.stopInertia();
    if (this.hint) this.hint.classList.toggle('is-hidden', this.interacted || i !== 0);
  };

  /* ---- caricamento fotogrammi ---- */

  Viewer.prototype.preload = function () {
    if (this.preloadStarted || !this.frames.length) return;
    this.preloadStarted = true;
    var self = this;
    var queue = this.frames.map(function (f, i) { return i; });
    var retried = [];
    var active = 0;

    function pump() {
      while (active < 6 && queue.length) {
        (function (idx) {
          active++;
          var im = new Image();
          im.onload = function () {
            active--;
            self.loaded[idx] = true;
            self.loadedCount++;
            self.settled++;
            // aggiorna subito il frame corrente; se il frame 0 è fallito
            // mostra comunque il primo fotogramma disponibile
            if (idx === self.frameIndex || !self.spinImg.getAttribute('src')) {
              self.spinImg.src = self.frames[idx].u;
            }
            self.updateLoader();
            pump();
          };
          im.onerror = function () {
            active--;
            if (!retried[idx]) {
              retried[idx] = true;
              queue.push(idx); // un solo retry per frame
            } else {
              self.settled++; // frame perso: showFrame userà il più vicino caricato
            }
            self.updateLoader();
            pump();
          };
          im.src = self.frames[idx].u;
        })(queue.shift());
      }
    }
    pump();
  };

  Viewer.prototype.updateLoader = function () {
    if (!this.loader) return;
    var pct = Math.min(Math.round(this.settled / this.frames.length * 100), 100);
    this.loader.textContent = pct + '%';
    if (this.settled >= this.frames.length) this.loader.classList.add('is-hidden');
  };

  Viewer.prototype.showFrame = function (i) {
    var n = this.frames.length;
    if (!n) return;
    i = ((Math.round(i) % n) + n) % n;
    this.frameIndex = i;
    // se il frame non è ancora caricato usa il più vicino disponibile all'indietro
    var j = i, guard = 0;
    while (!this.loaded[j] && guard < n) { j = (j - 1 + n) % n; guard++; }
    if (this.loaded[j]) this.spinImg.src = this.frames[j].u;
  };

  /* ---- drag / inerzia / zoom / rotellina ---- */

  Viewer.prototype.bindSpin = function (area) {
    var self = this;
    var dragging = false;
    var activePointer = null;
    var startX = 0;
    var startY = 0;
    var startFrame = 0;
    var maxMove = 0;
    var lastX = 0;
    var lastT = 0;
    var velocity = 0;

    var unzoomPending = false;
    var unzoomX = 0;
    var unzoomY = 0;

    function resetPointerState() {
      dragging = false;
      unzoomPending = false;
      activePointer = null;
      area.classList.remove('is-dragging');
    }

    function markInteracted() {
      if (self.interacted) return;
      self.interacted = true;
      if (self.hint) self.hint.classList.add('is-hidden');
    }

    area.addEventListener('pointerdown', function (e) {
      // solo puntatore primario e tasto sinistro: pinch e tasto destro non guidano lo spin
      if (!e.isPrimary || (e.pointerType === 'mouse' && e.button !== 0)) return;
      if (activePointer !== null) return;
      activePointer = e.pointerId;
      if (self.zoomed) {
        unzoomPending = true;
        unzoomX = e.clientX;
        unzoomY = e.clientY;
        return;
      }
      dragging = true;
      startX = lastX = e.clientX;
      startY = e.clientY;
      lastT = e.timeStamp;
      startFrame = self.frameIndex;
      maxMove = 0;
      velocity = 0;
      self.stopInertia();
      area.classList.add('is-dragging');
      try { area.setPointerCapture(e.pointerId); } catch (err) { /* no-op */ }
    });

    area.addEventListener('pointermove', function (e) {
      if (activePointer !== null && e.pointerId !== activePointer) return;
      if (self.zoomed) {
        self.panZoom(e);
        return;
      }
      if (!dragging) return;
      var dx = e.clientX - startX;
      maxMove = Math.max(maxMove, Math.abs(dx), Math.abs(e.clientY - startY));
      if (maxMove > 4) markInteracted();
      var pxPerFrame = Math.max(area.getBoundingClientRect().width, 1) / self.frames.length;
      // segno negativo: il fronte dell'orologio segue il dito (frame crescenti = rotazione verso sinistra)
      self.showFrame(startFrame - dx / pxPerFrame);
      var dt = e.timeStamp - lastT;
      if (dt > 0) velocity = (e.clientX - lastX) / dt; // px/ms
      lastX = e.clientX;
      lastT = e.timeStamp;
    });

    function release(e) {
      if (activePointer !== null && e.pointerId !== activePointer) return;
      activePointer = null;
      if (unzoomPending) {
        unzoomPending = false;
        if (Math.abs(e.clientX - unzoomX) < 6 && Math.abs(e.clientY - unzoomY) < 6) {
          self.setZoom(false);
        }
        return;
      }
      if (!dragging) return;
      dragging = false;
      area.classList.remove('is-dragging');
      if (e.timeStamp - lastT > 80) velocity = 0; // fling stantio: fermo prima del rilascio
      if (maxMove < 6) {
        self.toggleZoom(e);
      } else {
        self._lastDragEnd = e.timeStamp; // sopprime il click-chiusura sintetico post-drag
        if (Math.abs(velocity) > 0.25 && !prefersReducedMotion()) {
          self.startInertia(velocity, area);
        }
      }
    }
    area.addEventListener('pointerup', release);
    area.addEventListener('pointercancel', resetPointerState);
    // rete di sicurezza: pointerup inghiottito (es. context menu) rilascia comunque lo stato
    area.addEventListener('lostpointercapture', resetPointerState);

    area.addEventListener('wheel', function (e) {
      if (self.zoomed) return;
      e.preventDefault();
      if (e.ctrlKey) return; // pinch da trackpad: non ruotare
      // asse dominante; con deltaX il fronte segue lo swipe come nel drag
      var d = Math.abs(e.deltaX) > Math.abs(e.deltaY) ? 0 - e.deltaX : e.deltaY;
      if (!d) return;
      markInteracted();
      self.showFrame(self.frameIndex + (d > 0 ? 1 : -1));
    }, { passive: false });

    // tastiera: frecce = rotazione, Invio/Spazio = zoom
    area.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft' || e.key === 'ArrowRight') {
        e.preventDefault();
        e.stopPropagation();
        markInteracted();
        self.showFrame(self.frameIndex + (e.key === 'ArrowRight' ? 1 : -1));
      } else if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        var r = area.getBoundingClientRect();
        self.toggleZoom({ clientX: r.left + r.width / 2, clientY: r.top + r.height / 2 });
      }
    });
  };

  Viewer.prototype.startInertia = function (velocity, area) {
    var self = this;
    var pos = this.frameIndex;
    var pxPerFrame = Math.max(area.getBoundingClientRect().width, 1) / this.frames.length;
    var v = Math.max(-4, Math.min(4, velocity)); // px/ms, con tetto anti-runaway
    var last = performance.now();

    function step(now) {
      var dt = now - last;
      last = now;
      pos -= (v * dt) / pxPerFrame;
      v *= Math.pow(0.94, dt / 16.7);
      self.showFrame(pos);
      if (Math.abs(v) > 0.02) {
        self._raf = requestAnimationFrame(step);
      } else {
        self._raf = null;
      }
    }
    this._raf = requestAnimationFrame(step);
  };

  Viewer.prototype.stopInertia = function () {
    if (this._raf) { cancelAnimationFrame(this._raf); this._raf = null; }
  };

  Viewer.prototype.toggleZoom = function (e) {
    this.setZoom(!this.zoomed, e);
  };

  Viewer.prototype.setZoom = function (on, e) {
    this.zoomed = on;
    this.spinWrap.classList.toggle('is-zoomed', on);
    if (on && e) this.panZoom(e);
    if (!on) this.spinImg.style.transformOrigin = '';
    if (this.hint) this.hint.classList.toggle('is-hidden', this.interacted || on || this.current !== 0);
  };

  Viewer.prototype.panZoom = function (e) {
    var r = this.spinWrap.getBoundingClientRect();
    var x = Math.min(Math.max((e.clientX - r.left) / r.width, 0), 1) * 100;
    var y = Math.min(Math.max((e.clientY - r.top) / r.height, 0), 1) * 100;
    this.spinImg.style.transformOrigin = x + '% ' + y + '%';
  };

  /* ---- init ---- */

  function init() {
    var dataEl = document.querySelector('script[data-rcpo360-data]');
    if (!dataEl) return;
    var data;
    try { data = JSON.parse(dataEl.textContent); } catch (err) { return; }
    if (!data || !(data.frames || []).length) return;
    var viewer = new Viewer(data);
    var triggers = document.querySelectorAll('[data-rcpo360-trigger]');
    Array.prototype.forEach.call(triggers, function (t) {
      t.addEventListener('click', function (e) {
        e.preventDefault();
        viewer.open();
      });
    });
  }

  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
})();
